var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "desciption-content" }, [
          _c(
            "div",
            { staticStyle: { width: "70%" } },
            [
              _c(
                "el-descriptions",
                { staticClass: "margin-top", attrs: { column: 6, border: "" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                B/L No：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.blNo) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                ETA(ABOUT)：\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.eta) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Agent：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n               " +
                            _vm._s(_vm.tableData.agent) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Vessel：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.vesselName) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Voyage：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.voyageNo) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                POL：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                 " +
                            _vm._s(_vm.tableData.pol) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                POD：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                 " +
                            _vm._s(_vm.tableData.pod) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Customer：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.customerName) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Consignee：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.consigneeCode) +
                            "\n"
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Shipper：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.shipperCode) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                Date Of Payment：\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.dateOfPayment) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Remark：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n               " +
                            _vm._s(_vm.tableData.remark) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 1,
                        labelStyle: "text-align:center;",
                        contentStyle:
                          "background-color: rgba(209, 232, 255, 1);font-size: 14px;text-align:center;\n                                  font-weight: 600;color:black",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                SIZE/TYPE\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", {}, [
                        _vm._v("\n                UNIT\n              "),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", {
                    attrs: {
                      span: 5,
                      labelStyle:
                        "background-color: transparent;border-right-color:transparent",
                      contentStyle: "width:0;padding:0",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 1,
                        labelStyle:
                          "background-color: transparent;text-align:center;font-weight:500",
                        contentStyle:
                          "font-size: 14px;text-align:center;\n                                  font-weight: 500;",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.detailInfo.sizeType) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", {}, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.detailInfo.unit) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", {
                    attrs: {
                      span: 5,
                      labelStyle:
                        "background-color: transparent;border-right-color:transparent",
                      contentStyle: "width:0;padding:0",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 1,
                        labelStyle: "text-align:center;",
                        contentStyle:
                          "background-color: rgba(209, 232, 255, 1);font-size: 14px;text-align:center;\n                                  font-weight: 600;color:black;width:170px",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Currency\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", {}, [
                        _vm._v(
                          "\n                Freight and Charges\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 5,
                        labelStyle:
                          "text-align:center;transparent;border-right-color:transparent",
                        contentStyle:
                          "background-color: rgba(209, 232, 255, 1);font-size: 14px;text-align:center;\n                                  font-weight: 600;color:black;width:170px",
                      },
                    },
                    [
                      _c("template", { slot: "label" }),
                      _vm._v(" "),
                      _c("span", {}),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 1 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                USD\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                 " +
                            _vm._s(_vm.tableData.usd) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", {
                    attrs: {
                      span: 5,
                      labelStyle:
                        "background-color: transparent;border-right-color:transparent",
                      contentStyle: "width:0;padding:0",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 1 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n               YEN\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n               " +
                            _vm._s(_vm.tableData.jpy) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", {
                    attrs: {
                      span: 5,
                      labelStyle:
                        "background-color: transparent;border-right-color:transparent",
                      contentStyle: "width:0;padding:0",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 1,
                        labelStyle: "text-align:center;",
                        contentStyle:
                          "background-color: rgba(209, 232, 255, 1);font-size: 14px;text-align:center;\n                                  font-weight: 600;color:black",
                      },
                    },
                    [
                      _c("template", { slot: "label" }),
                      _vm._v(" "),
                      _c("span", {}, [
                        _vm._v(
                          "\n                Confirm Status\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 5,
                        labelStyle: "text-align:center;",
                        contentStyle:
                          "background-color: rgba(209, 232, 255, 1);font-size: 14px;text-align:center;\n                                  font-weight: 600;color:black",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                Confirm Date\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", {}),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 1 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Agent：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n               " +
                            _vm._s(_vm.getTableListItem(_vm.tableData.agn)) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 5,
                        labelStyle:
                          "background-color: transparent;border-right-color:transparent;text-align:center;font-weight:500",
                        contentStyle: "width:0;padding:0",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.creditAgnDate) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 1 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Customer：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.getTableListItem(_vm.tableData.cst)) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 5,
                        labelStyle:
                          "background-color: transparent;border-right-color:transparent;text-align:center;font-weight:500",
                        contentStyle: "width:0;padding:0",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.creditCstDate) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 1 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                SITC Japan：\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                 " +
                            _vm._s(_vm.getTableListItem(_vm.tableData.sit)) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        span: 5,
                        labelStyle:
                          "background-color: transparent;border-right-color:transparent;text-align:center;font-weight:500",
                        contentStyle: "width:0;padding:0",
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.creditSitDate) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                Changed：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.changed) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n                D/O LESS：\n              "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                   " +
                            _vm._s(_vm.getTableListItem(_vm.tableData.doLess)) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 6 } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          "\n                RELEASE TO：\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tableData.releaseTo) +
                            "\n              "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "margin-bottom": "20px", "font-size": "14px" } },
      [_c("b", [_vm._v("\n          Credit Data Detail\n        ")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }